module.exports = __webpack_public_path__ + "static/media/trofeo1.51fe1380.png";